import {
	GridCellProps,
	GridColumnProps,
	GridHeaderCellProps,
	GridCustomCellProps,
} from "@progress/kendo-react-grid";
import CustomDropDownList from "ui/dropDown";
import { getPackagesApi, getProductsApi, getMinimumProductPriceApi } from "api/common";
import { ListItemProps } from "@progress/kendo-react-dropdowns";
import React, { FC, useState, useEffect, useRef } from "react";
import { useToastStore } from "store/toast";
import {
	GridCommandCellMultiple,
	NumericalHeader,
} from "ui/grid/GridCommandCell";
import { NumericalCell } from "ui/grid/NumericalCellInput";
import { FooterAggregateSum } from "ui/grid/GridFooters";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import i18n from "../../../../i18n";
import { NumericalCellAutoFocus } from "ui/grid/NumericalCellInputFocus";

let t = i18n.t;

interface StepTwoGridColumnProps {
	update: (data: any, type?: "product" | "packaging" | "other") => void;
	openNoteModal: (props: GridCellProps) => void;
	onSelectPackage: (data: any) => void;
	hasMeetRequirement: (data: any, field: string) => boolean;
	showError: boolean;
	isNarrowView: boolean;
	onChange?: (data: any) => void;
	onBlur?: (data: any) => void;
	onFocus?: (data: any) => void;
	onValueChange?: (e: any) => void;
	startDeletingLine: (data: any) => void;
	data: any[];
}

const validateGrossLiveWeight = (items: any) => {
	if (!items.grossLiveWeightKg)
		return false;

	if (items.grossLiveWeightKg && items.netLiveWeightKg && items.grossLiveWeightKg < items.netLiveWeightKg)
		return false;

	return true;
}

const validateNetLiveWeight = (items: any) => {
	if (!items.netLiveWeightKg)
		return false;

	if (items.netLiveWeightKg && items.grossLiveWeightKg && items.netLiveWeightKg > items.grossLiveWeightKg)
		return false;

	return true;
}

export const stepTwoGridColumns = ({
	showError,
	isNarrowView,
	...prop
}: StepTwoGridColumnProps) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "productId",
			title: t("Product"),
			// editable: true,
			className: `no-border col-min-width`,
			//minResizableWidth: 250,
			//width: (isNarrowView ? "150px" : ""),
			cells: {
				data: (props) => {
					let code = props.dataItem[props.field as any] || null;
					let display = props.dataItem["product"];
					let value = {} as any;
					if (code !== null) {
						value.id = code;
						value.name = display;
					}

					return (
						<td
							className="no-border"
							style={{
								paddingLeft: "1px !important"
							}}
						>
							<CustomDropDownList
								data={[]}
								value={value}
								onSelect={(data) => {
									props.dataItem[props.field as any] = data.id;
									props.dataItem["product"] = data.name;
									props.dataItem["piecesMandatory"] =
										data.isNumberOfUnitsMandatory === true ? 1 : 0;
									prop.update(props.dataItem, "product");
								}}
								serverFilterApi={(text) => getProductsApi(text, undefined, undefined, true, 0)}
								defaultItem={{ id: null, name: "Velg Vare" }}
								filterable={true}
								serverFilter={true}
								textField={"name"}
								dataItemKey={"id"}
								showError={
									!prop.hasMeetRequirement(props.dataItem,props.field as any) && showError
								}
								borderColor="none"
							/>
						</td>
					);
				},
			},
		},
		{
			field: "packagingCode",
			title: t("Packaging"),
			className: ` no-border`,
			//	width: "350px",
			// editable: true,
			// width: "150px",

			cells: {
				data: (props) => {
					let code = props.dataItem[props.field as any] || null;
					let display = props.dataItem["packaging"];

					let value = {} as any;
					if (code !== null) {
						value.code = code;
						value.name = display;
					}
					return (
						<td className="no-border" style={{ minWidth: "250px" }}>
							<CustomDropDownList
								data={[]}
								value={value}
								// onChange={onChange}
								filterable={true}
								serverFilter={true}
								onSelect={(data) => {
									props.dataItem[props.field as any] = data.code;
									props.dataItem["packaging"] = data.name;
									prop.onSelectPackage(props.dataItem);
									// prop.update(props.dataItem, "packaging");
								}}
								defaultItem={{ code: null, name: t("ChoosePackaging") }}
								textField={"name"}
								dataItemKey={"code"}
								itemRender={itemRender}
								showError={
									!prop.hasMeetRequirement(
										props.dataItem,
										props.field as any,
									) && showError
								}
								serverFilterApi={getPackagesApi}
								borderColor="none"
							/>
						</td>
					);
				},
			},
		},
		{
			field: "numberOfUnits",
			title: t("Units"),
			editable: true,
			width: "105px",

			cells: {
				data: (props) => (
					<NumericalCellAutoFocus {...props} {...prop} decimalScale={0} />
				),

				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						field={"numberOfUnits"}
					/>
				),
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "numberOfPallets",
			title: "Ant.Pal.",
			editable: true,
			width: "85px",

			cells: {
				data: (props) => (
					<NumericalCellAutoFocus {...props} {...prop} decimalScale={0} />
				),
				// edit: {
				// 	text: (props) => {
				// 		return <NumericalCellAutoFocus {...props} decimalScale={0} />;
				// 	},
				// },
				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						field={"numberOfPallets"}
					/>
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "numberOfPieces",
			title: t("Pieces"),
			editable: true,
			width: "85px",

			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={0}
						showError={
							!prop.hasMeetRequirement(props.dataItem, props.field as any) &&
							showError
						}
					/>
				),

				// edit: {
				// 	text: (props) => {
				// 		return <NumericalCellAutoFocus {...props} decimalScale={0} />;
				// 	},
				// },
				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						field={"numberOfPieces"}
					/>
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},

		{
			field: "averageLiveWeightKg",
			title: t("Average"),
			editable: true,
			//format: "{0:d}",
			width: "95px",
			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={2}
						fixedDecimalScale={true}
					/>
				),

				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},

		{
			field: "grossLiveWeightKg",
			title: t("GrossWeight"),
			editable: true,
			//format: "{0:d}",
			width: "125px",
			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={2}
						fixedDecimalScale={true}
						showError={
							!validateGrossLiveWeight(props.dataItem) && showError
						}
					/>
				),

				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						decimalScale={2}
						fixedDecimalScale={true}
						field={"grossLiveWeightKg"}
					/>
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "netLiveWeightKg",
			title: t("NetWeight"),
			editable: true,
			//format: "{0:d}",
			width: "125px",
			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={2}
						fixedDecimalScale={true}
						showError={
							!validateNetLiveWeight(props.dataItem) &&
							showError
						}
					/>
				),

				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						decimalScale={2}
						fixedDecimalScale={true}
						field={"netLiveWeightKg"}
					/>
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "price",
			title: t("Price"),
			editable: true,
			width: "110px",
			cells: {
				data: (props) => (
					<PriceCell
						{...props}
						showError={showError}
						hasMeetRequirement={prop.hasMeetRequirement}
						onChange={prop.onChange}
						onBlur={prop.onBlur}
						onFocus={prop.onFocus}
						onValueChange={prop.onValueChange}
					/>
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} show_error`,
		},
		{
			field: "",
			title: "",
			width: "90px",
			cell: (props) => (
				<GridCommandCellMultiple
					{...props}
					style={{}}
					items={[
						{
							onclick: prop.openNoteModal,
							iconName: ICON_NAMES.Note,
						},
						{
							onclick: prop.startDeletingLine,
							iconName: ICON_NAMES.Delete,
						},
					]}
				/>
			),
		},
	];

	return gridItems;
};

const itemRender = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps,
) => {
	const itemChildren = [
		<span key={1} style={{ width: "40px" }}>
			&nbsp; {itemProps.dataItem.code}{" "}
		</span>,
		<span key={2}>&nbsp; {itemProps.dataItem.name} </span>,
	];

	return React.cloneElement(li, li.props, itemChildren);
};

// Module-level caches: all persist across remounts, keyed by lineId
const minimumPriceCache = new Map<any, number | null>();
const prevProductIdMap = new Map<any, any>();
const NO_MINIMUM_PRICE = 999999;

interface PriceCellProps extends GridCustomCellProps {
	showError: boolean;
	hasMeetRequirement: (data: any, field: string) => boolean;
	onChange?: (e: any) => void;
	onBlur?: (e: any) => void;
	onFocus?: (e: any) => void;
	onValueChange?: (e: any) => void;
}

const PriceCell: FC<PriceCellProps> = ({
	showError,
	hasMeetRequirement,
	onChange,
	onBlur,
	onFocus,
	onValueChange,
	...props
}) => {
	const lineId = props.dataItem.id;
	const productId = props.dataItem.productId;

	const { showWarning } = useToastStore();

	const onChangeRef = useRef(onChange);
	onChangeRef.current = onChange;
	const dataItemRef = useRef(props.dataItem);
	dataItemRef.current = props.dataItem;
	const fieldRef = useRef(props.field);
	fieldRef.current = props.field;
	const showWarningRef = useRef(showWarning);
	showWarningRef.current = showWarning;

	const [minimumPrice, setMinimumPrice] = useState<number | null>(
		() => minimumPriceCache.has(lineId) ? minimumPriceCache.get(lineId)! : null
	);

	const applyMinimumPrice = (minPrice: number) => {
		if (minPrice === NO_MINIMUM_PRICE) return;
		const currentPrice = dataItemRef.current[fieldRef.current as any];
		if (currentPrice === null || currentPrice === undefined || currentPrice < minPrice) {
			if (onChangeRef.current) {
				onChangeRef.current({
					dataItem: dataItemRef.current,
					field: fieldRef.current,
					value: minPrice,
				});
			}
			showWarningRef.current(
				t("PriceSetToMinimum", { price: minPrice }),
				{ duration: 4000, position: "bottom-center" }
			);
		}
	};

	useEffect(() => {
		if (!lineId || !productId) {
			setMinimumPrice(null);
			return;
		}

		// Survives remounts � prevProductIdMap is module-level, not a React ref
		const prevProductId = prevProductIdMap.get(lineId);
		const isProductChange = prevProductId !== undefined && prevProductId !== productId;
		prevProductIdMap.set(lineId, productId);

		if (isProductChange) {
			minimumPriceCache.delete(lineId);
		}

		if (minimumPriceCache.has(lineId)) {
			const cached = minimumPriceCache.get(lineId)!;
			setMinimumPrice(cached);
			if (isProductChange && cached !== null) applyMinimumPrice(cached);
			return;
		}

		getMinimumProductPriceApi(lineId)
			.then((response) => {
				minimumPriceCache.set(lineId, response);
				setMinimumPrice(response);
				if (isProductChange && response !== null) applyMinimumPrice(response);
			})
			.catch(() => {
				minimumPriceCache.set(lineId, null);
				setMinimumPrice(null);
			});
	}, [lineId, productId]);

	const handleChange = (e: any) => {
		if (minimumPrice !== null && minimumPrice !== NO_MINIMUM_PRICE &&
			(e.value === null || e.value === undefined || e.value < minimumPrice)) {
			e.value = minimumPrice;
			showWarning(
				t("PriceSetToMinimum", { price: minimumPrice }),
				{ duration: 4000, position: "bottom-center" }
			);
		}
		if (onChange) onChange(e);
	};

	const price = props.dataItem[props.field as any];
	const hasPriceValue = hasMeetRequirement(props.dataItem, props.field as any);
	const isBelowMinimum = minimumPrice !== null && minimumPrice !== NO_MINIMUM_PRICE
		&& price !== null && price < minimumPrice;
	const isPriceInvalid = !hasPriceValue || isBelowMinimum;

	return (
		<NumericalCellAutoFocus
			decimalScale={2}
			fixedDecimalScale={true}
			{...props}
			onChange={handleChange}
			onBlur={onBlur}
			onFocus={onFocus}
			onValueChange={onValueChange}
			showError={isPriceInvalid && showError}
		/>
	);
};
